import { createContext } from 'react';

export const PageUrlContext = createContext<{
  newPage: any;
  setNewPage: any;
}>({ newPage: null, setNewPage: () => {} });
